export default {
      id: "contact-white-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "sprite.svg#contact-white",
      toString: function () {
        return this.url;
      }
    }